module.exports = __webpack_public_path__ + "media/images/icons/skills-development_02-bb118ba097ac1573102aeddd3c80187d.svg";